<template>
  <div class="home-container">
    <div class="home-content">
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="商品名称"
                prop="name"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.name"
                  placeholder="请输入商品名称进行检索"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="sort" label="排序" align="center">
        </el-table-column>
        <el-table-column prop="name" label="商品名称" align="center">
        </el-table-column>
        <el-table-column prop="img" label="兑换商品图片" align="center" width="100">
          <template slot-scope="scope">
            <el-image :src="scope.row.img" style="width: 70px;height: 70px;" fit="cover" :preview-src-list="[scope.row.img]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="integral" label="所需积分" align="center">
        </el-table-column>
        <el-table-column prop="stockNum" label="库存数量" align="center">
        </el-table-column>
        <el-table-column prop="tips" label="适用" align="center">
          <template slot-scope="scope">
            物业服务台兑换
          </template>
        </el-table-column>
        <el-table-column prop="status" label="是否启用" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >查看/修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small" style="color: #f53f3f;"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%" @close="close" :close-on-click-modal="false">
        <el-form
          ref="form"
          :model="addData"
          label-width="150px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="排序：" prop="sort">
                <el-input-number style="width: 250px" v-model="addData.sort" :precision="0" :min="0" :max="99999999" placeholder="请输入排序"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品名称：" prop="name">
                <el-input
                  placeholder="请输入商品名称"
                  v-model="addData.name"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="所需积分：" prop="integral">
                <el-input-number style="width: 250px" v-model="addData.integral" :precision="0" :min="0" :max="99999999" placeholder="请输入所需积分"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="库存数量：" prop="stockNum">
                <el-input-number style="width: 250px" v-model="addData.stockNum" :precision="0" :min="0" :max="99999999" placeholder="请输入库存数量"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="上传兑换商品图片：" prop="img">
                <upload
                  :url.sync="addData.img"
                  :src="addData.img"
                  type="img"
                  :width="642"
                  :height="642"
                ></upload>
                <div style="color: red">*(建议尺寸642px * 642px)）</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="核销有效时间：" prop="validTime">
                <el-date-picker
                  v-model="addData.validTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :disabled="modalTitle == '修改'?true:false"
                  :picker-options="pickerOptions"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
export default {
  components: {
    upload,
  },
  data() {
    return {
      searchForm: {
      },
      houseFlag: true,
      modalTitle: "新增",
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        img: "",
        sort: 100,
        name: "",
        integral: "",
        stockNum: "",
        validTime: "",
      },
      addDataRules: {
        img: [{ required: true, message: "请上传banner", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        integral: [{ required: true, message: "请输入所需积分", trigger: "blur" }],
        stockNum: [{ required: true, message: "请输入库存数量", trigger: "blur" }],
        validTime: [{ required: true, message: "请选择核销有效时间", trigger: "change" }],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    // 修改用户状态
    updataStatus(row) {
      let data = {
        id: row.id,
        status: row.status ? 1 : -1,
      };
      this.$Apis.giftUpdStatus(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.addData.sort = 100
      this.addData.stockNum = ''
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.modalTitle = "修改";
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.giftDel({ ids:id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    close(){
      this.$refs.form.resetFields();
      this.isAddModal = false;
      for (let item in this.addData) {
        this.addData[item] = "";
      }
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            img: this.addData.img,
            name: this.addData.name,
            sort: this.addData.sort,
            integral: this.addData.integral,
            stockNum: this.addData.stockNum,
            validTime: this.addData.validTime,

          };
          this.$Apis.giftAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      this.isShowloading = true;
      this.currentPage = ind == 1 ? 1 : this.currentPage
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        ...this.searchForm
      };
      this.$Apis.giftGetList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.status = item.status == 1 ? true : false;
            item.ind = ind + 1;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>